import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/LanguageSwitch.css';

const LanguageSwitch = ({ compact = false, className = '' }) => {
    const { language, setLanguage } = useLanguage();

    return (
        <div className={`language-switch-container ${compact ? 'compact' : ''} ${className}`}>
            <button
                type="button"
                className={`lang-btn ${language === 'fr' ? 'active' : ''}`}
                onClick={() => setLanguage('fr')}
                title="Passer en Français"
                aria-label="Français"
            >
                <span className="lang-flag">🇫🇷</span>
                <span className="lang-label">FR</span>
            </button>
            <button
                type="button"
                className={`lang-btn ${language === 'zh' ? 'active' : ''}`}
                onClick={() => setLanguage('zh')}
                title="切换到中文 (Switch to Chinese)"
                aria-label="中文"
            >
                <span className="lang-flag">🇨🇳</span>
                <span className="lang-label">中文</span>
            </button>
        </div>
    );
};

export default LanguageSwitch;
